import React from 'react'
import './DoubleHeading.css'

const DoubleHeading = (props) => {
  return (
    <div className='DoubleHeading mb-4'>
        {/* <h2 className='big_title'>{props?.heading}</h2> */}
        <h3 className='title'>{props?.heading}</h3>
    </div>
  )
}

export default DoubleHeading
